import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  OnDestroy,
  SimpleChanges,
  ChangeDetectorRef
} from "@angular/core";
import { Router } from "@angular/router";
import { interval, Subscription } from "rxjs";
import { NavService } from "../../services/nav.service";
import { TranslateService } from "@ngx-translate/core";
import { DOCUMENT } from "@angular/common";
import {
  CmsMenu,
  OrderCustomerClient,
  ThongBaoClient,
  ThongBaoDto,
  TypeNotificationEnum,
} from "../../api-connector/sso-connector";
import { AuthService } from "../../services/auth.service";
import { CustomizerService } from "../../services/customizer.service";
import { UploadService } from "../../services/upload.service";
import { AlertService } from "../../services/alert.service";
import { DrawerService } from "../drawer/drawer.service";
import { ThongTinCaNhanComponent } from "../../../module/thong-tin-ca-nhan/thong-tin-ca-nhan.component";
import { NotificationService } from "../../services/notification.service";
import { NotificationsDrawerComponent } from "../notifications/notifications.component";
var body = document.getElementsByTagName("body")[0];

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  fullName!: string;
  public menuItems!: CmsMenu[];
  public items!: CmsMenu[];
  public searchResult = false;
  public searchResultEmpty = false;
  public openNav = false;
  private document: any;
  // tslint:disable-next-line: variable-name
  public right_sidebar = false;
  public text!: string;
  public elem: any;
  public isOpenMobile = false;
  @Output() rightSidebarEvent = new EventEmitter<boolean>();
  avatarId!: string;
  urlLogo = "../../../../assets/images/logo/compact-logo.png";
  private subscriptions: Subscription[] = [];
  constructor(
    public navServices: NavService,
    // @Inject(DOCUMENT) private document: any, // Removed injection
    private auth: AuthService,
    private uploadService: UploadService,
    private translate: TranslateService,
    public customize: CustomizerService,
    private thongBaoClient: ThongBaoClient,
    private orderCustomerClient: OrderCustomerClient,
    private alertService: AlertService,
    private drawerService: DrawerService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    const layoutVersion = customize.getLayoutVersion();
    if (layoutVersion === "dark-only") {
      this.urlLogo = "../../../../assets/images/logo/compact-logo.png";
    }
    translate.setDefaultLang("en");
    this.document = document; // Assign global document
  }

  ngOnDestroy() {
    this.removeFix();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  onLogout() {
    this.alertService
      .confirm(
        "Bạn có chắc là muốn thoát ra khỏi hệ thống không ?",
        "Đăng xuất hệ thống",
      )
      .subscribe((x) => {
        if (x) {
          this.auth.logout();
        }
      });
  }

  getLinkAvatar() {
    if (
      this.avatarId == "null" ||
      this.avatarId == undefined ||
      this.avatarId == "" ||
      this.avatarId == null
    ) {
      return "assets/images/dashboard/user.png";
    }
    return this.uploadService.getUrlFile(this.avatarId);
  }

  right_side_bar() {
    this.right_sidebar = !this.right_sidebar;
    this.rightSidebarEvent.emit(this.right_sidebar);
  }

  collapseSidebar() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }

  public changeLanguage(lang: any) {
    this.translate.use(lang);
  }

  searchTerm(term: any) {
    term ? this.addFix() : this.removeFix();
    if (!term) {
      return (this.menuItems = []);
    }
    const items: any[] = [];
    term = term.toLowerCase();
    this.items.filter((menuItems) => {
      if (
        menuItems.title?.toLowerCase().includes(term) &&
        menuItems.type === "link"
      ) {
        items.push(menuItems);
      }
      if (!menuItems.children) {
        return false;
      }
      menuItems.children.filter((subItems) => {
        if (
          subItems.title?.toLowerCase().includes(term) &&
          subItems.type === "link"
        ) {
          subItems.icon = menuItems.icon;
          items.push(subItems);
        }
        if (!subItems.children) {
          return false;
        }
        subItems.children.filter((suSubItems) => {
          if (suSubItems.title?.toLowerCase().includes(term)) {
            suSubItems.icon = menuItems.icon;
            items.push(suSubItems);
          }
        });
      });
      this.checkSearchResultEmpty(items);
      this.menuItems = items;
    });
  }

  checkSearchResultEmpty(items: any[]) {
    if (!items.length) {
      this.searchResultEmpty = true;
    } else {
      this.searchResultEmpty = false;
    }
  }

  addFix() {
    this.searchResult = true;
    body.classList.add("offcanvas");
  }

  removeFix() {
    this.searchResult = false;
    body.classList.remove("offcanvas");
    this.text = "";
  }
  ngOnInit() {
    if (
      this.auth.getAccount().laQuanTriVien == undefined ||
      this.auth.getAccount().laQuanTriVien == null
    ) {
      this.auth.logout();
    }
    this.elem = document.documentElement;
    this.navServices.items.subscribe((menuItems) => {
      this.items = menuItems;
    });
    this.avatarId = this.auth.getAvatarId() || "";
    this.fullName = this.auth.getAccount().fullName || "";

    this.subscriptions.push(
      this.auth.currentmMenuConfig.subscribe((z) => {
        if (z) {
          this.avatarId = z;
          this.cdr.detectChanges();
        }
      })
    );
  }

  toggleFullScreen() {
    this.navServices.fullScreen = !this.navServices.fullScreen;
    if (this.navServices.fullScreen) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    } else {
      if (!this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  openUserInfo() {
    this.drawerService.open(ThongTinCaNhanComponent, {
      title: "Thông tin cá nhân",
      width: "min(800px, 90vw)",
    });
  }
}
